import {Box, Stack} from '@mui/material';
import {ComponentType, ReactNode} from 'react';
import {Outlet} from 'react-router-dom';
import {allowScrollY, isMobileDevice} from '../../common';
import InsetArea from './InsetArea';

export default function Layout(props: {
	children?: ReactNode;
	header?: ComponentType;
	footer?: ComponentType;
	scroll?: boolean;
	snap?: boolean;
	fillTop?: boolean;
	fillBottom?: boolean;
	insetColor?: string;
}) {
	const {children, header, footer, scroll, snap, fillTop, fillBottom, insetColor = 'background.appbar'} = props;
	const isMobile = isMobileDevice();

	const HeaderSlot = header ?? null;
	const FooterSlot = footer ?? null;

	return (
		<InsetArea fillTop={fillTop} fillBottom={fillBottom} bgcolor={insetColor}>
			<Stack width="100%" height="100%" alignItems="center">
				<Stack id="container" width="100%" maxWidth={isMobile ? '100%' : '1440px'} height="100%" alignItems="center" justifyContent="space-between">
					{HeaderSlot && (
						<Box id="header-area" width="100%">
							<HeaderSlot />
						</Box>
					)}

					<Stack
						id="scrollable-box"
						width="100%"
						flex={1}
						minHeight={0}
						sx={{...(scroll ? allowScrollY : {}), scrollSnapType: snap ? {xs: 'none', md: 'y mandatory'} : 'none'}}
					>
						<Outlet />

						{children}
					</Stack>

					{FooterSlot && (
						<Box id="footer-area" width="100%">
							<FooterSlot />
						</Box>
					)}
				</Stack>
			</Stack>
		</InsetArea>
	);
}
